module.exports = __webpack_public_path__ + "static/poslovanje-85decef51971748ecb078e72c62ec00b.svg";